export const greyPalette = {
    50: '#f3f3f3',
    100: '#E1E1E1',
    200: '#CDCDCD',
    300: '#B9B9B9',
    400: '#AAAAAA',
    500: '#9B9B9B',
    600: '#939393',
    700: '#898989',
    800: '#7f7f7f',
    900: '#6d6d6d',
    A100: '#fdeeee',
    A200: '#f8c0c0',
    A400: '#ff8686',
    A700: '#ff6d6d'
}
